import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "@components/Table";
import { ButtonSecondary, ButtonPrimaryLink } from "@components/Button";
import { deleteBrandById } from "@actions/brands.action";
import Modal from "@components/Modal";
import { Span } from "@styles/typography";
import { Row, Indent } from "@styles/grid";

const EditBrand = ({ brandId }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.brands.loading);

  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const handleDeleteBrand = () => async () => {
    try {
      await dispatch(deleteBrandById(brandId));
      setIsRemoveModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return (
    <Row justify="flex-end" padding="0 2rem 0 0">
      <Indent margin="0 1.5rem 0 0">
        <ButtonPrimaryLink uppercase href={`/brands/${brandId}`} outlined size="small" weight="bold">
          edit
        </ButtonPrimaryLink>
      </Indent>
      <ButtonSecondary uppercase onClick={() => setIsRemoveModalOpen(true)} size="small" weight="bold">
        Remove
      </ButtonSecondary>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove Brand">
        <Indent margin="4rem 0">
          <Span size={1.8}>Are you sure you want to delete this brand?</Span>
        </Indent>
        <Row justify="flex-end">
          <Indent margin="0 2rem 0">
            <ButtonSecondary outlined onClick={() => setIsRemoveModalOpen(false)} uppercase>
              Close
            </ButtonSecondary>
          </Indent>
          <ButtonSecondary autoFocus onClick={handleDeleteBrand()} uppercase disabled={loading}>
            Remove
          </ButtonSecondary>
        </Row>
      </Modal>
    </Row>
  );
};

const BrandsTable = () => {
  const { brands, fetching } = useSelector(({ brands }) => brands);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Logo",
        accessor: "image",
        Cell: ({ row }) =>
          row.original.image && (
            <img
              style={{ width: "auto", height: 30, objectFit: "contain" }}
              src={row.original.image}
              alt={row.original.name}
            />
          ),
      },
      {
        id: "colEdit",
        Cell: ({ row }) => <EditBrand brandId={row.original.id} />,
      },
    ],
    []
  );

  const data = useMemo(() => brands, [brands]);

  return <Table columns={columns} data={data} loading={fetching} hasGlobalFilter />;
};

export default BrandsTable;
